'use client';

/* Barre de recherche réutilisable (tunnel de réservation + tunnel carte cadeau). */

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  placeholder: string;
  clearLabel: string;
}

export function SearchInput({ value, onChange, placeholder, clearLabel }: SearchInputProps) {
  return (
    <div className="bt-search">
      <input
        type="text"
        className="bt-search__input"
        placeholder={placeholder}
        value={value}
        onChange={(e) => onChange(e.target.value)}
      />
      {value && (
        <button type="button" className="bt-search__clear" onClick={() => onChange('')} aria-label={clearLabel}>
          ×
        </button>
      )}
    </div>
  );
}
